/** ----------------数据字典-------------**/
export default {
  // 构件状态
  compStatus: [
    {
      value: -2,
      label: '处理失败'
    }, {
      value: 2,
      label: '处理中'
    }, {
      value: 3,
      label: '待发布'
    }, {
      value: 99,
      label: '已发布'
    },
  ],
  // 构件状态
  compStatusStr: [
    {
      value: 'PROCESSED_FAILED',
      label: '处理失败'
    },
    {
      value: 'PROCESSING',
      label: '处理中'
    },
    {
      value: 'TOBE_RELEASED',
      label: '待发布'
    },
    {
      value: 'RELEASED',
      label: '已发布'
    },
  ],
  // acs图块状态
  blockStatus: [
    {
      value: 'PROCESSING',
      label: '处理中'
    }, {
      value: 'PROCESSED_SUCCEEDED',
      label: '处理成功'
    }, {
      value: 'PROCESSED_FAILED',
      label: '处理失败'
    },
  ],
  placeholderOptionsAll: [
    {
      value: 'COMMON-PLAN',
      label: '通用>平面'
    }, {
      value: 'COMMON-ELEVATION',
      label: '通用>立面'
    }, {
      value: 'COMMON-PROFILE',
      label: '通用>侧面'
    }, {
      value: 'ELECTRIC-PLAN',
      label: '电气>平面'
    },
  ],
  // 是否选项（bool）
  booleanOptions: [
    {
      value: true,
      label: '是'
    }, {
      value: false,
      label: '否'
    },
  ],
  // 状态选项
  statusOptions: [
    {
      value: 'TOBE_RELEASED',
      label: '待发布'
    }, {
      value: 'RELEASED',
      label: '已发布'
    }
  ],
  // 资源状态
  statusOptionsAll: [
    {
      value: 'PROCESSING',
      label: '解析中'
    },
    {
      value: 'PROCESSED_FAILED',
      label: '解析失败'
    },
    {
      value: 'TOBE_RELEASED',
      label: '解析成功'
    },
    // {
    //   value: 'RELEASED',
    //   label: '已发布'
    // },
    // {
    //   value: 'TOBE_RELEASED',
    //   label: '待发布'
    // },
    // {
    //   value: 'PROCESSING',
    //   label: '处理中'
    // },
    // {
    //   value: 'PROCESSED_FAILED',
    //   label: '处理失败'
    // },
  ],
  // 产品参数写入构件状态
  writeStatusConfig: [
    {
      status: 'TOBE_RELATE',
      class: 'ft-grey',
      text: '未关联'
    }, {
      status: 'TOBE_WRITE',
      class: 'ft-yellow',
      text: '未写入'
    }, {
      status: 'WRITING',
      class: 'ft-blue',
      text: '写入中'
    }, {
      status: 'WRITE_FAILURE',
      class: 'ft-red',
      text: '写入失败'
    }, {
      status: 'WRITE_SUCCESS',
      class: 'ft-green',
      text: '写入成功'
    },
  ],

  // 根据type获取acs图块的名称
  transferToCn(type) {
    switch (type) {
      case 'PLAN':
        return '俯视图'
      case 'ELEVATION':
        return '正视图'
      case 'PROFILE':
        return '侧视图'
      case 'System':
        return '系统'
      case 'ThreeD':
        return '3D'
    }
  }
}
